import {Routes, RouterModule} from "@angular/router";
import {StarterViewComponent} from "./views/appviews/starterview.component";
import {BasicLayoutComponent} from "./components/common/layouts/basicLayout.component";
import { NgModule } from '@angular/core';
import { UsuarioAutenticadoGuard } from "./core/guards/usuario-autenticado.guard";
import { NotFoundComponent } from "./components/common/not-found/not-found.component";

const ROUTES:Routes = [
  {
    path: '', component: BasicLayoutComponent,
    children: [
      {path: 'starterview', component: StarterViewComponent}
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },  
  {
    path: 'configuracion',
    loadChildren: () => import('./views/configuracion/configuracion.module').then(m => m.ConfiguracionModule)
  },
  {
    path: 'liquidacion',
    loadChildren: () => import('./views/liquidacion/liquidacion.module').then(m => m.LiquidacionModule)
  },
  {
    path: 'personal',
    loadChildren: () => import('./views/personal/personal.module').then(m => m.PersonalModule)
  },
  {
    path: 'dashboards',
    loadChildren: () => import('./views/dashboards/dashboards.module').then(m => m.DashboardsModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./views/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'usuario',
    loadChildren: () => import('./views/usuarios/usuarios.module').then(m => m.UsuariosModule)
  },
  {
    path: '404', component: NotFoundComponent,
  },
  // Handle all other routes
  { path: '**', redirectTo: 'Personal' }
];

@NgModule({
  imports: [RouterModule.forRoot(ROUTES, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
